import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import { ParticipantStatus, ChallengeStatus } from '../../utils/const'
import { translateGameType, showScore } from '../../utils/translate'
import { localeDateFormat } from '../../utils/datetime'

const MatchHistoryTable = ({ matches }) => (

    <table className="table lobby-table table-hover table-striped match-history">
        <thead>
            <tr>
                <th></th>
                <th>Score</th>
                <th>Type</th>
                <th>ID</th>
                <th>Date played</th>
                <th className="text-right">Actions</th>
            </tr>
        </thead>
        <tbody>

            {typeof matches === 'undefined' ? '' : (matches.map((match, index) => (
                <tr key={match.challengeId}>
                    <td className="count">
                        {placementFormat(match.challengeStatus, match.challengeError, match.participantStatus, match.participantError, match.placement)}
                    </td>
                    <td className="points text-left">
                        {showScore({ strokes: match.strokes, points: match.points })}
                    </td>
                    <td>
                        {translateGameType(match.gameType)}
                    </td>
                    <td>
                        #{match.challengeId}
                    </td>

                    <td>
                        {localeDateFormat(match.ended)}
                    </td>

                    <td className="text-right">
                        <Link className="table-button" to={'/challenge/' + match.challengeId}>
                            View
                        </Link>
                    </td>
                </tr>
            )))}
        </tbody>
    </table>
)

function dateFormat(date) {

    if (typeof date === 'undefined' || date === null) {
        return "Not played yet";
    }

    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(played)

    return formated;
}


function placementFormat(challengeStatus, challengeError, participantStatus, participantError, placement) {
    if (!challengeError && !participantError && challengeStatus === ChallengeStatus.DONE && participantStatus === ParticipantStatus.DONE) {
        if (placement === 1) {
            return <img className="medal" src="/images/WGC_gold_ball.png" alt="" />
        }
        else if (placement === 2) {
            return <img className="medal" src="/images/WGC_silver_ball.png" alt="" />
        }
        else if (placement === 3) {
            return <img className="medal" src="/images/WGC_bronze_ball.png" alt="" />
        }
        else {
            return "#" + placement;
        }
    }
    else {
        return "-";
    }
}

export default MatchHistoryTable